import { useMemo } from 'react';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useStrictPDFData } from '../usePDFData';
import { Container } from './styled';
export function ErrorLayer(props) {
    const { page, scale = 1 } = props;
    const { isPageCorrupted } = useStrictPDFData();
    const viewport = useMemo(() => page.getViewport({ scale }), [scale, page]);
    if (isPageCorrupted(page.pageNumber)) {
        return (<Container $width={viewport.width} $height={viewport.height}>
        <Falcon $size={36} $color="gray.500" icon="file-circle-xmark"/>
      </Container>);
    }
    return null;
}
